<template>
    <ais-instant-search
        id="courses"
        :index-name="indexName"
        :search-client="searchClient"
        :routing="routing"
    >
        <ais-configure :filters="aisFilters()"></ais-configure>

        <div id="articles-menu" class="pt-4 pb-3">
            <div id="articles-search-box" class="row">
                <div class="col">
                    <ais-search-box>
                        <template
                            v-slot="{
                                currentRefinement,
                                isSearchStalled,
                                refine,
                            }"
                        >
                            <div class="input-group">
                                <input
                                    ref="inputSearchArticles"
                                    type="search"
                                    :value="currentRefinement"
                                    @input="
                                        refineArticlesBySearchInput(
                                            refine,
                                            'inputSearchArticles'
                                        )
                                    "
                                    class="form-control form-control-lg"
                                    :placeholder="
                                        trans('user.cart.gift_card.search') +
                                        '...'
                                    "
                                />
                                <button
                                    id="button-search-articles"
                                    class="btn btn-primary ml-2 mr-0"
                                    :title="trans('user.cart.gift_card.search')"
                                    @click="
                                        refineArticlesBySearchInput(
                                            refine,
                                            'inputSearchArticles'
                                        )
                                    "
                                >
                                    <i class="fa fa-search"></i>
                                </button>
                                <button
                                    id="button-reset-search-articles"
                                    class="btn btn-secondary ml-2"
                                    :title="trans('common.cancel')"
                                    @click="onClickClearRefinements(refine)"
                                >
                                    <i class="fa fa-times-circle"></i>
                                </button>
                            </div>
                        </template>
                    </ais-search-box>
                </div>
            </div>

            <div id="search-tags" class="row mt-lg-2">
                <div
                    class="col-12 col-md d-flex flex-wrap justify-content-between"
                >
                    <!-- City menu -->
                    <div class="dropdown mt-2 mt-xl-0">
                        <button
                            class="btn btn-white no-caps dropdown-toggle"
                            type="button"
                            id="city-dropdown"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            data-display="static"
                        >
                            <span class="icon-location"></span>
                            {{
                                trans('pages/course/search.filters.title.city')
                            }}
                        </button>
                        <div
                            class="dropdown-menu wide-dropdown-menu"
                            aria-labelledby="city-dropdown"
                        >
                            <ais-menu
                                :id="'regular-filters'"
                                class="text-center"
                                attribute="city"
                                ref="cityMenu"
                                :show-more="true"
                                :show-more-limit="25"
                                :sort-by="['isRefined', 'count:desc']"
                                :class-names="{
                                    'ais-Menu': '',
                                    'ais-Menu-link':
                                        'mb-1 text-dark text-capitalize',
                                    'ais-Menu-showMore':
                                        'text-center btn btn-link text-muted btn-sm d-none d-lg-inline-block',
                                    'ais-SearchBox-form': 'input-group mb-2',
                                    'ais-SearchBox-input':
                                        'form-control border-right-0',
                                    'ais-SearchBox-submit':
                                        'btn btn-outline-secondary disabled',
                                    'ais-SearchBox-reset':
                                        'btn btn-outline-light border-secondary border-left-0',
                                }"
                            >
                                <template
                                    v-slot="{
                                        items,
                                        refine,
                                        createURL,
                                        canToggleShowMore,
                                        toggleShowMore,
                                        isShowingMore,
                                    }"
                                >
                                    <div class="ais-RefinementList-searchBox">
                                        <form
                                            action=""
                                            role="search"
                                            novalidate="novalidate"
                                            class="ais-SearchBox-form input-group mb-2"
                                        >
                                            <input
                                                v-model="searchCityTerm"
                                                type="search"
                                                autocorrect="off"
                                                autocapitalize="none"
                                                autocomplete="off"
                                                data-lpignore="true"
                                                data-form-type="other"
                                                spellcheck="false"
                                                required="required"
                                                maxlength="512"
                                                :aria-label="
                                                    trans(
                                                        'pages/course/search.filters.dropdown.search'
                                                    )
                                                "
                                                :placeholder="
                                                    trans(
                                                        'pages/course/search.filters.dropdown.search_bar.city'
                                                    )
                                                "
                                                class="ais-SearchBox-input form-control border-right-0"
                                                @input="
                                                    searchCityTermInput(
                                                        $event.currentTarget
                                                            .value
                                                    )
                                                "
                                            />
                                            <button
                                                type="submit"
                                                :title="
                                                    trans(
                                                        'pages/course/search.filters.dropdown.search'
                                                    )
                                                "
                                                class="ais-SearchBox-submit btn btn-outline-secondary disabled"
                                                @click.prevent=""
                                            >
                                                <svg
                                                    role="img"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="10"
                                                    height="10"
                                                    viewBox="0 0 40 40"
                                                    class="ais-SearchBox-submitIcon"
                                                >
                                                    <path
                                                        d="M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z"
                                                        fillRule="evenodd"
                                                    ></path>
                                                </svg>
                                            </button>
                                            <button
                                                v-if="searchCityTerm"
                                                type="reset"
                                                :title="
                                                    trans(
                                                        'pages/course/search.filters.dropdown.clear'
                                                    )
                                                "
                                                class="ais-SearchBox-reset btn btn-outline-light border-secondary border-left-0"
                                                @click="searchCityTermReset()"
                                            >
                                                <svg
                                                    role="img"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="10"
                                                    height="10"
                                                    viewBox="0 0 20 20"
                                                    class="ais-SearchBox-resetIcon"
                                                >
                                                    <path
                                                        d="M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z"
                                                        fillRule="evenodd"
                                                    ></path>
                                                </svg>
                                            </button>
                                        </form>
                                    </div>
                                    <div
                                        class="ais-Menu-noResults"
                                        v-if="
                                            !filterCityMenuItems(items)
                                                .length && searchCityTerm != ''
                                        "
                                    >
                                        {{
                                            trans(
                                                'pages/course/search.no_results'
                                            )
                                        }}
                                    </div>
                                    <ul class="ais-Menu-list text-left" v-else>
                                        <li
                                            v-for="item in filterCityMenuItems(
                                                items
                                            )"
                                            :key="item.value"
                                            class="ais-Menu-item mb-2"
                                        >
                                            <a
                                                class="ais-Menu-link text-dark mb-1"
                                                :href="createURL(item.value)"
                                                @click.prevent="
                                                    refineArticles(
                                                        refine,
                                                        item.value
                                                    )
                                                "
                                            >
                                                <span
                                                    v-if="item.isRefined"
                                                    class="ais-Menu-label text-capitalize"
                                                    >{{ item.label }}</span
                                                >
                                                <span
                                                    v-else
                                                    class="ais-Menu-label text-capitalize font-weight-normal"
                                                    >{{ item.label }}</span
                                                >
                                            </a>
                                        </li>
                                    </ul>
                                    <button
                                        class="ais-Menu-showMore text-center btn btn-link text-muted btn-sm d-none d-lg-inline-block"
                                        @click="toggleShowMore"
                                        :disabled="
                                            !canToggleShowMore ||
                                            lockToggleShowMore
                                        "
                                    >
                                        <span>{{
                                            isShowingMore
                                                ? trans(
                                                      'pages/course/search.filters.dropdown.show_less'
                                                  )
                                                : trans(
                                                      'pages/course/search.filters.dropdown.show_more'
                                                  )
                                        }}</span>
                                    </button>
                                </template>
                            </ais-menu>
                        </div>
                    </div>

                    <!-- Levels filter -->
                    <div class="dropdown mt-2 mt-xl-0">
                        <button
                            class="btn btn-white no-caps dropdown-toggle"
                            type="button"
                            id="levels-dropdown"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            {{
                                trans('pages/course/search.filters.title.level')
                            }}
                        </button>
                        <div
                            class="dropdown-menu dropdown-menu-keep-open"
                            aria-labelledby="levels-dropdown"
                        >
                            <ais-refinement-list attribute="levels">
                                <template
                                    v-slot="{
                                        items,
                                        isShowingMore,
                                        isFromSearch,
                                        canToggleShowMore,
                                        refine,
                                        createURL,
                                        toggleShowMore,
                                        searchForItems,
                                        sendEvent,
                                    }"
                                >
                                    <ul class="ais-RefinementList-list mb-0">
                                        <li
                                            class="ais-RefinementList-item"
                                            v-for="item in items"
                                            :key="item.value"
                                        >
                                            <div
                                                class="custom-control custom-checkbox"
                                                :href="createURL(item.value)"
                                                :class="
                                                    item.isRefined
                                                        ? 'font-weight-bold'
                                                        : ''
                                                "
                                                @click.prevent="
                                                    refineArticles(
                                                        refine,
                                                        item.value
                                                    )
                                                "
                                            >
                                                <input
                                                    :id="
                                                        'tag-checkbox-' +
                                                        item.value
                                                    "
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    :checked="!!item.isRefined"
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    :for="
                                                        'tag-checkbox-' +
                                                        item.value
                                                    "
                                                >
                                                    <span
                                                        class="ais-RefinementList-labelText form-check-label text-capitalize"
                                                    >
                                                        {{ item.label }}
                                                    </span>
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                </template>
                            </ais-refinement-list>
                        </div>
                    </div>

                    <!-- Tags filter -->
                    <div class="dropdown mt-2 mt-xl-0">
                        <button
                            class="btn btn-white no-caps dropdown-toggle"
                            type="button"
                            id="tags-dropdown"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            {{ trans('pages/course/search.filters.title.tag') }}
                        </button>
                        <div
                            class="dropdown-menu wide-dropdown-menu dropdown-menu-keep-open"
                            aria-labelledby="tags-dropdown"
                        >
                            <ais-refinement-list
                                attribute="tags"
                                :limit="6"
                                :sort-by="sortTags"
                                :show-more="true"
                                :show-more-limit="25"
                            >
                                <template
                                    v-slot="{
                                        items,
                                        isShowingMore,
                                        isFromSearch,
                                        canToggleShowMore,
                                        refine,
                                        createURL,
                                        toggleShowMore,
                                        searchForItems,
                                        sendEvent,
                                    }"
                                >
                                    <div class="ais-RefinementList-searchBox">
                                        <form
                                            action=""
                                            role="search"
                                            novalidate="novalidate"
                                            class="ais-SearchBox-form input-group mb-2"
                                        >
                                            <div class="input-group">
                                                <input
                                                    type="search"
                                                    autocapitalize="none"
                                                    autocomplete="off"
                                                    data-lpignore="true"
                                                    data-form-type="other"
                                                    spellcheck="false"
                                                    :aria-label="
                                                        trans(
                                                            'pages/course/search.filters.dropdown.search_bar.tag'
                                                        )
                                                    "
                                                    :placeholder="
                                                        trans(
                                                            'pages/course/search.filters.dropdown.search_bar.tag'
                                                        )
                                                    "
                                                    class="ais-SearchBox-input form-control"
                                                    @input="
                                                        searchForItems(
                                                            $event.currentTarget
                                                                .value
                                                        )
                                                    "
                                                />
                                                <div class="input-group-append">
                                                    <span
                                                        class="input-group-text"
                                                        ><i
                                                            class="fa fa-search"
                                                        ></i
                                                    ></span>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <ul class="ais-RefinementList-list mb-0">
                                        <li
                                            class="ais-RefinementList-item"
                                            v-for="item in items"
                                            :key="item.value"
                                        >
                                            <div
                                                class="custom-control custom-checkbox"
                                                :href="createURL(item.value)"
                                                :class="
                                                    item.isRefined
                                                        ? 'font-weight-bold'
                                                        : ''
                                                "
                                                @click.prevent="
                                                    refineArticles(
                                                        refine,
                                                        item.value
                                                    )
                                                "
                                            >
                                                <input
                                                    :id="
                                                        'tag-checkbox-' +
                                                        item.value
                                                    "
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    :checked="!!item.isRefined"
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    :for="
                                                        'tag-checkbox-' +
                                                        item.value
                                                    "
                                                >
                                                    <span
                                                        class="ais-RefinementList-labelText form-check-label text-capitalize"
                                                    >
                                                        {{ item.label }}
                                                    </span>
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                    <button
                                        class="ais-RefinementList-showMore text-center btn btn-link text-muted btn-sm d-none d-lg-inline-block"
                                        @click="toggleShowMore"
                                    >
                                        {{
                                            !isShowingMore
                                                ? trans(
                                                      'pages/course/search.filters.dropdown.show_more'
                                                  )
                                                : trans(
                                                      'pages/course/search.filters.dropdown.show_less'
                                                  )
                                        }}
                                    </button>
                                </template>
                            </ais-refinement-list>
                        </div>
                    </div>

                    <!-- Device types filter -->
                    <div class="dropdown mt-2 mt-xl-0">
                        <button
                            class="btn btn-white no-caps dropdown-toggle"
                            type="button"
                            id="device-types-dropdown"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            {{
                                trans(
                                    'pages/course/search.filters.title.device'
                                )
                            }}
                        </button>
                        <div
                            class="dropdown-menu wide-dropdown-menu dropdown-menu-keep-open"
                            aria-labelledby="device-types-dropdown"
                        >
                            <ais-refinement-list
                                attribute="device_types"
                                :limit="6"
                                :sort-by="sortTags"
                                :show-more="true"
                                :show-more-limit="25"
                            >
                                <template
                                    v-slot="{
                                        items,
                                        isShowingMore,
                                        isFromSearch,
                                        canToggleShowMore,
                                        refine,
                                        createURL,
                                        toggleShowMore,
                                        searchForItems,
                                        sendEvent,
                                    }"
                                >
                                    <div class="ais-RefinementList-searchBox">
                                        <form
                                            action=""
                                            role="search"
                                            novalidate="novalidate"
                                            class="ais-SearchBox-form input-group mb-2"
                                        >
                                            <div class="input-group">
                                                <input
                                                    type="search"
                                                    autocapitalize="none"
                                                    autocomplete="off"
                                                    data-lpignore="true"
                                                    data-form-type="other"
                                                    spellcheck="false"
                                                    :aria-label="
                                                        trans(
                                                            'pages/course/search.filters.dropdown.search_bar.device'
                                                        )
                                                    "
                                                    :placeholder="
                                                        trans(
                                                            'pages/course/search.filters.dropdown.search_bar.device'
                                                        )
                                                    "
                                                    class="ais-SearchBox-input form-control"
                                                    @input="
                                                        searchForItems(
                                                            $event.currentTarget
                                                                .value
                                                        )
                                                    "
                                                />
                                                <div class="input-group-append">
                                                    <span
                                                        class="input-group-text"
                                                        ><i
                                                            class="fa fa-search"
                                                        ></i
                                                    ></span>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <ul class="ais-RefinementList-list mb-0">
                                        <li
                                            class="ais-RefinementList-item"
                                            v-for="item in items"
                                            :key="item.value"
                                        >
                                            <div
                                                class="custom-control custom-checkbox"
                                                :href="createURL(item.value)"
                                                :class="
                                                    item.isRefined
                                                        ? 'font-weight-bold'
                                                        : ''
                                                "
                                                @click.prevent="
                                                    refineArticles(
                                                        refine,
                                                        item.value
                                                    )
                                                "
                                            >
                                                <input
                                                    :id="
                                                        'tag-checkbox-' +
                                                        item.value
                                                    "
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    :checked="!!item.isRefined"
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    :for="
                                                        'tag-checkbox-' +
                                                        item.value
                                                    "
                                                >
                                                    <span
                                                        class="ais-RefinementList-labelText form-check-label text-capitalize"
                                                    >
                                                        {{ item.label }}
                                                    </span>
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                    <button
                                        class="ais-RefinementList-showMore text-center btn btn-link text-muted btn-sm d-none d-lg-inline-block"
                                        @click="toggleShowMore"
                                    >
                                        {{
                                            !isShowingMore
                                                ? trans(
                                                      'pages/course/search.filters.dropdown.show_more'
                                                  )
                                                : trans(
                                                      'pages/course/search.filters.dropdown.show_less'
                                                  )
                                        }}
                                    </button>
                                </template>
                            </ais-refinement-list>
                        </div>
                    </div>

                    <!-- Is pack toggle -->
                    <div class="dropdown mt-2 mt-xl-0">
                        <button
                            class="btn btn-white no-caps dropdown-toggle"
                            type="button"
                            id="is-pack-dropdown"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            data-display="static"
                        >
                            <i class="fas fa-box text-secondary"></i>
                            {{
                                trans(
                                    'pages/course/search.filters.title.is_pack'
                                )
                            }}
                        </button>
                        <div
                            class="dropdown-menu dropdown-menu-keep-open"
                            aria-labelledby="is-pack-dropdown"
                        >
                            <ais-refinement-list
                                attribute="is_pack"
                                :transformItems="transformBooleanItems"
                                :sort-by="['isRefined', 'count:desc']"
                            >
                                <template
                                    v-slot="{
                                        items,
                                        isShowingMore,
                                        isFromSearch,
                                        canToggleShowMore,
                                        refine,
                                        createURL,
                                        toggleShowMore,
                                        searchForItems,
                                        sendEvent,
                                    }"
                                >
                                    <ul class="ais-RefinementList-list mb-0">
                                        <li
                                            class="ais-RefinementList-item"
                                            v-for="item in items"
                                            :key="item.value"
                                        >
                                            <div
                                                class="custom-control custom-checkbox"
                                                :href="createURL(item.value)"
                                                :class="
                                                    item.isRefined
                                                        ? 'font-weight-bold'
                                                        : ''
                                                "
                                                @click.prevent="
                                                    refineArticles(
                                                        refine,
                                                        item.value
                                                    )
                                                "
                                            >
                                                <input
                                                    :id="
                                                        'tag-checkbox-' +
                                                        item.value
                                                    "
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    :checked="!!item.isRefined"
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    :for="
                                                        'tag-checkbox-' +
                                                        item.value
                                                    "
                                                >
                                                    <span
                                                        class="ais-RefinementList-labelText form-check-label text-capitalize"
                                                    >
                                                        {{ item.label }}
                                                    </span>
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                </template>
                            </ais-refinement-list>
                        </div>
                    </div>

                    <!-- Is online toggle -->
                    <div class="dropdown mt-2 mt-xl-0">
                        <button
                            class="btn btn-white no-caps dropdown-toggle"
                            type="button"
                            id="is-online-dropdown"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            data-display="static"
                        >
                            <i class="fas fa-video text-secondary"></i>
                            {{
                                trans(
                                    'pages/course/search.filters.title.is_online'
                                )
                            }}
                        </button>
                        <div
                            class="dropdown-menu dropdown-menu-keep-open"
                            aria-labelledby="is-online-dropdown"
                        >
                            <ais-refinement-list
                                attribute="is_online"
                                :transformItems="transformBooleanItems"
                                :sort-by="['isRefined', 'count:desc']"
                            >
                                <template
                                    v-slot="{
                                        items,
                                        isShowingMore,
                                        isFromSearch,
                                        canToggleShowMore,
                                        refine,
                                        createURL,
                                        toggleShowMore,
                                        searchForItems,
                                        sendEvent,
                                    }"
                                >
                                    <ul class="ais-RefinementList-list mb-0">
                                        <li
                                            class="ais-RefinementList-item"
                                            v-for="item in items"
                                            :key="item.value"
                                        >
                                            <div
                                                class="custom-control custom-checkbox"
                                                :href="createURL(item.value)"
                                                :class="
                                                    item.isRefined
                                                        ? 'font-weight-bold'
                                                        : ''
                                                "
                                                @click.prevent="
                                                    refineArticles(
                                                        refine,
                                                        item.value
                                                    )
                                                "
                                            >
                                                <input
                                                    :id="
                                                        'tag-checkbox-' +
                                                        item.value
                                                    "
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    :checked="!!item.isRefined"
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    :for="
                                                        'tag-checkbox-' +
                                                        item.value
                                                    "
                                                >
                                                    <span
                                                        class="ais-RefinementList-labelText form-check-label text-capitalize"
                                                    >
                                                        {{ item.label }}
                                                    </span>
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                </template>
                            </ais-refinement-list>
                        </div>
                    </div>
                </div>
            </div>

            <div id="current-filters" class="row mt-2">
                <div class="col-12 col-md text-center text-md-left">
                    <ais-current-refinements
                        :class-names="{
                            'ais-CurrentRefinements': '',
                            'ais-CurrentRefinements--noRefinement': '',
                            'ais-CurrentRefinements-list': 'mb-0',
                            'ais-CurrentRefinements-item': '',
                            'ais-CurrentRefinements-label': 'd-none',
                            'ais-CurrentRefinements-category': '',
                            'ais-CurrentRefinements-categoryLabel': '',
                            'ais-CurrentRefinements-delete': '',
                        }"
                    >
                        <template v-slot="{ items, createURL }">
                            <ul class="ais-CurrentRefinements-list mb-0">
                                <li
                                    v-for="item in items"
                                    :key="item.attribute"
                                    class="ais-CurrentRefinements-item d-inline-block"
                                >
                                    <div
                                        v-for="refinement in item.refinements"
                                        :key="
                                            [
                                                refinement.attribute,
                                                refinement.type,
                                                refinement.value,
                                                refinement.operator,
                                            ].join(':')
                                        "
                                        class="ais-CurrentRefinements-category d-inline-block mr-2 bg-secondary text-white font-weight-bold px-2 py-1 mt-2 mt-md-0"
                                    >
                                        <span
                                            class="active-filter"
                                            :title="
                                                trans(
                                                    'pages/course/search.filters.remove_filter'
                                                )
                                            "
                                            data-toggle="tooltip"
                                        >
                                            <a
                                                :href="createURL(refinement)"
                                                @click.prevent="
                                                    refineArticlesByRemovingFilter(
                                                        refinement,
                                                        item
                                                    )
                                                "
                                                class="ais-CurrentRefinements-delete"
                                                role="button"
                                            >
                                                ✕
                                                <span
                                                    v-if="
                                                        refinement.label.toLowerCase() ==
                                                        'true'
                                                    "
                                                    class="ais-CurrentRefinements-categoryLabel"
                                                >
                                                    {{
                                                        trans(
                                                            'pages/course/search.filters.refinements.' +
                                                                refinement.attribute.toLowerCase()
                                                        )
                                                    }}
                                                </span>
                                                <span
                                                    v-else-if="
                                                        refinement.label.toLowerCase() ==
                                                        'false'
                                                    "
                                                    class="ais-CurrentRefinements-categoryLabel"
                                                >
                                                    {{
                                                        trans(
                                                            'pages/course/search.filters.refinements.not_' +
                                                                refinement.attribute.toLowerCase()
                                                        )
                                                    }}
                                                </span>
                                                <span
                                                    v-else
                                                    class="ais-CurrentRefinements-categoryLabel text-capitalize"
                                                >
                                                    {{ refinement.label }}
                                                </span>
                                            </a>
                                        </span>
                                    </div>
                                </li>
                            </ul>
                        </template>
                    </ais-current-refinements>
                </div>
                <!-- Clear refinements -->
                <div class="col-12 col-md-4 col-lg-3 mt-2 mt-md-0">
                    <ais-clear-refinements>
                        <div
                            class="pr-0 text-center text-md-right"
                            slot-scope="{ canRefine, refine, createURL }"
                        >
                            <a
                                class="reset-filter-button"
                                :class="canRefine ? '' : 'selected'"
                                :href="createURL()"
                                @click.prevent="onClickClearRefinements(refine)"
                            >
                                <i class="fa fa-times"></i>
                                {{
                                    trans(
                                        'pages/course/search.filters.reset_filters'
                                    )
                                }}
                            </a>
                        </div>
                    </ais-clear-refinements>
                </div>
            </div>
        </div>

        <div id="currency-switcher">
            <div class="d-flex h-100 align-items-stretch">
                <div class="d-flex align-items-center">
                    <span class="icon-background bg-primary text-white">
                        <span
                            id="currency-switcher-dollar"
                            class="fas fa-dollar-sign"
                            alt=""
                        ></span>
                    </span>
                    <span class="icon-background bg-primary text-white">
                        <span
                            id="currency-switcher-yen"
                            class="fas fa-yen-sign"
                            alt=""
                        ></span>
                    </span>
                </div>
                <div class="d-flex align-items-center">
                    <span
                        id="currency-switcher-message"
                        v-html="
                            trans('pages/articles.switch_currency.help_text', {
                                ':currency': selectedCurrencyLabel,
                            })
                        "
                    >
                    </span>
                </div>
                <div class="flex-fill text-lg-right text-center">
                    <button
                        id="currency-switch-suggestion-cancel"
                        class="btn btn-secondary btn text-white font-weight-bold mr-1"
                    >
                        {{
                            trans(
                                'pages/articles.switch_currency.cancel_button'
                            )
                        }}
                    </button>
                    <button
                        id="currency-switch-suggestion-button"
                        class="btn btn-primary btn text-white font-weight-bold ml-1"
                        data-toggle="modal"
                        data-target="#currency-chooser-modal"
                    >
                        {{
                            trans(
                                'pages/articles.switch_currency.change_currency_button'
                            )
                        }}
                    </button>
                </div>
            </div>
        </div>

        <div id="articles-list" class="row mt-2">
            <ais-hits id="search-results" class="col">
                <div
                    class="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-3"
                    slot-scope="{ items }"
                    v-if="items.length > 0"
                >
                    <div
                        class="col mb-4 search-result"
                        v-for="item in items"
                        :key="item.key"
                    >
                        <a itemprop="url" :href="item.url">
                            <div class="card border-0 h-100">
                                <div
                                    class="text-dark item-picture overflow-hidden"
                                    itemprop="picture_url"
                                    :style="{
                                        backgroundImage: `url('${item.picture_url}')`,
                                    }"
                                ></div>
                                <div class="course-type-stickers">
                                    <meta
                                        itemprop="is_online"
                                        :content="item.is_online.toString()"
                                    />
                                    <meta
                                        itemprop="type"
                                        :content="item.type"
                                    />
                                    <div
                                        v-if="item.is_online && !item.is_pack"
                                        class="online-simple-sticker sticker"
                                    >
                                        <i class="fas fa-video pr-2"></i>
                                        Live / Online
                                    </div>
                                    <div
                                        v-if="!item.is_online && item.is_pack"
                                        class="pack-simple-sticker sticker"
                                    >
                                        <i class="fas fa-box pr-2"></i>
                                        Pack
                                    </div>
                                    <div
                                        v-if="item.is_online && item.is_pack"
                                        class="pack-online-double-sticker d-flex"
                                    >
                                        <div
                                            class="online-double-sticker sticker"
                                        >
                                            <i class="fas fa-video pr-2"></i>
                                            Live / Online
                                        </div>
                                        <div
                                            class="pack-double-sticker sticker"
                                        >
                                            <i class="fas fa-box pr-2"></i>
                                            Pack
                                        </div>
                                    </div>
                                </div>
                                <div class="discount-stickers">
                                    <div
                                        class="discount-amount-sticker sticker"
                                        v-if="item.discount_percentage !== null"
                                    >
                                        -{{ item.discount_percentage
                                        }}<span>%</span>
                                    </div>
                                    <div
                                        class="discount-amount-sticker sticker"
                                        v-else-if="
                                            item.discount_amount !== null
                                        "
                                    >
                                        -{{ item.discount_amount }}
                                    </div>
                                </div>
                                <div
                                    class="card-body d-flex align-items-center article-title"
                                >
                                    <h3 class="card-title mb-0">
                                        <span
                                            class="text-dark article-name"
                                            itemprop="name"
                                        >
                                            {{ item.name }}
                                        </span>
                                        <meta
                                            itemprop="locale"
                                            :content="item.locale"
                                        />
                                    </h3>
                                </div>
                                <div
                                    class="card-body py-0 d-flex align-items-center article-tags"
                                >
                                    <div itemprop="tags" class="card-text">
                                        <template v-for="tag in item.tags">
                                            <span class="badge" :key="tag">
                                                {{ tag }} </span
                                            >&nbsp;
                                        </template>
                                    </div>
                                </div>
                                <div class="card-body article-levels">
                                    <div class="row align-items-center">
                                        <div itemprop="levels" class="col">
                                            <template
                                                v-for="(
                                                    level, index
                                                ) in item.levels"
                                            >
                                                <span
                                                    v-if="index > 0"
                                                    :key="'separator-' + level"
                                                    >,&nbsp;</span
                                                >
                                                <span :key="level">
                                                    {{ level }}
                                                </span>
                                            </template>
                                        </div>
                                        <div
                                            class="col-4 text-right duration-label"
                                        >
                                            <div
                                                class="d-flex flex-row align-items-center justify-content-end"
                                            >
                                                <i
                                                    class="far fa-clock pr-2"
                                                ></i>
                                                <span
                                                    itemprop="duration"
                                                    v-html="item.duration"
                                                ></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body py-0 article-description">
                                    <div
                                        itemprop="in_short"
                                        class="in-short cropped-text"
                                        v-html="
                                            item.in_short != ''
                                                ? item.in_short
                                                : item.description
                                        "
                                    ></div>
                                </div>
                                <div class="card-footer border-0 article-price">
                                    <div class="d-flex justify-content-between">
                                        <div>
                                            <del>
                                                <span
                                                    class="original-price"
                                                    itemprop="original_price"
                                                    v-if="item.original_price"
                                                    v-html="item.original_price"
                                                ></span>
                                            </del>
                                            <span
                                                class="effective-price"
                                                itemprop="effective_price"
                                                v-html="item.effective_price"
                                            ></span>
                                            <meta
                                                itemprop="numeric_price"
                                                :content="item.numeric_price"
                                            />
                                            <meta
                                                itemprop="currency"
                                                :content="item.currency"
                                            />
                                        </div>
                                        <div class="text-right">
                                            <button class="btn btn-link h-100">
                                                {{ trans('common.more_info') }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div v-else>
                    <div
                        v-if="selectedCityHTML !== null"
                        class="text-center mt-3"
                    >
                        <div
                            v-html="
                                trans('course.currency.no_courses_available', {
                                    ':city': selectedCityHTML,
                                    ':currency': getSelectedCurrencyHTML(),
                                })
                            "
                        ></div>
                        <div class="mt-3">
                            <button
                                class="btn btn-primary"
                                data-toggle="modal"
                                data-target="#currency-chooser-modal"
                            >
                                {{ trans('course.currency.button_change') }}
                            </button>
                        </div>
                    </div>
                    <div v-else>
                        {{ trans('pages/course/search.no_results') }}
                    </div>
                </div>
            </ais-hits>
        </div>

        <div class="articles-pagination">
            <ais-pagination
                v-on:page-change="scrollUp"
                :show-first="false"
                :show-last="false"
                :class-names="{
                    'ais-Pagination': 'd-flex justify-content-center flex-wrap',
                    'ais-Pagination-list': 'pagination pagination-lg flex-wrap',
                    'ais-Pagination-item': 'page-item',
                    'ais-Pagination-item--disabled': 'disabled',
                    'ais-Pagination-item--selected': 'active',
                    'ais-Pagination-link': 'page-link',
                }"
            />
        </div>
        <div
            class="modal fade"
            id="currency-chooser-modal"
            data-keyboard="false"
            tabindex="-1"
        >
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-body">
                        <form
                            class="pt-2"
                            method="POST"
                            action="/internationalization/update"
                        >
                            <input type="hidden" name="_method" value="PUT" />
                            <div class="form-group">
                                <label for="select-currency">
                                    {{
                                        trans('course.currency.selector_label')
                                    }}
                                </label>
                                <select-currency
                                    id="select-currency-modal"
                                    custom-select-input-name="select-currency-modal"
                                ></select-currency>
                            </div>
                            <div class="text-center pt-2">
                                <button
                                    id="currency-switch-suggestion-choose"
                                    type="submit"
                                    class="btn btn-primary"
                                >
                                    {{ trans('course.currency.button_submit') }}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </ais-instant-search>
</template>

<script>
import algoliasearch from 'algoliasearch/lite';
import { history as historyRouter } from 'instantsearch.js/es/lib/routers';

export default {
    data() {
        let isHeaderSticky =
            document.getElementById('header-sticky') != undefined;
        let indexName = appData.page.vars.algoliaIndexName;
        let selectedCurrencyCode = window.app.getSelectedCurrency().code;
        let selectedCityHTML = null;
        let cityUrlParameter = new URL(location.href).searchParams.get('city');
        if (cityUrlParameter !== null) {
            let cities = appData.page.vars.cities;
            let city = cities.find((city) => city.slug === cityUrlParameter);
            selectedCityHTML = '<strong>' + city.name + '</strong>';
        }
        let selectedCurrencyLabel = window.app.getSelectedCurrency().name;

        return {
            citySelected: null,
            tagsOrder: appData.page.vars.tagsOrder,
            selectedCurrencyCode: selectedCurrencyCode,
            selectedCurrencyLabel: selectedCurrencyLabel,
            langFilter: 'locale:' + appData.trans.locale,
            searchClient: algoliasearch(
                appData.page.vars.algoliasearch.id,
                appData.page.vars.algoliasearch.api_key
            ),
            routing: {
                router: historyRouter({
                    createURL: ({ qsModule, routeState, location }) => {
                        const urlParts =
                            location.href.match(/^(.*)\/([A-z-]*)/);
                        const baseUrl = `${urlParts ? urlParts[1] : ''}/`;
                        const currentPage = `${urlParts ? urlParts[2] : ''}`;

                        const queryParameters = {};

                        if (routeState.query) {
                            queryParameters.query = encodeURIComponent(
                                routeState.query
                            );
                        }
                        if (routeState.page !== 1) {
                            queryParameters.page = routeState.page;
                        }
                        if (routeState.tags) {
                            queryParameters.tag = routeState.tags.map(
                                this.getTagSlug
                            );
                        }
                        if (routeState.levels) {
                            queryParameters.level = routeState.levels.map(
                                this.getLevelSlug
                            );
                        }
                        if (routeState.city) {
                            queryParameters.city = encodeURIComponent(
                                routeState.city
                            );
                        }
                        // if (routeState.currency) {
                        //     queryParameters.currency = encodeURIComponent(routeState.currency);
                        // }
                        if (routeState.is_online) {
                            queryParameters.is_online =
                                routeState.is_online.map(encodeURIComponent);
                        }
                        if (routeState.is_pack) {
                            queryParameters.is_pack =
                                routeState.is_pack.map(encodeURIComponent);
                        }
                        if (routeState.device_types) {
                            queryParameters.device_type =
                                routeState.device_types.map(
                                    this.getDeviceTypeSlug
                                );
                        }

                        const queryString = qsModule.stringify(
                            queryParameters,
                            {
                                addQueryPrefix: true,
                                arrayFormat: 'repeat',
                            }
                        );

                        return `${baseUrl}${currentPage}${queryString}`;
                    },

                    parseURL: ({ qsModule, location }) => {
                        const {
                            query = '',
                            page,
                            city = '',
                            // currency = '',
                            level = [],
                            tag = [],
                            is_online = [],
                            is_pack = [],
                            device_type = [],
                        } = qsModule.parse(location.search.slice(1));

                        // `qs` does not return an array when there's a single value.
                        const allTags = Array.isArray(tag)
                            ? tag
                            : [tag].filter(Boolean);

                        const allLevels = Array.isArray(level)
                            ? level
                            : [level].filter(Boolean);

                        const allIsOnline = Array.isArray(is_online)
                            ? is_online
                            : [is_online].filter(Boolean);

                        const allIsPack = Array.isArray(is_pack)
                            ? is_pack
                            : [is_pack].filter(Boolean);

                        const allDeviceTypes = Array.isArray(device_type)
                            ? device_type
                            : [device_type].filter(Boolean);

                        return {
                            query: decodeURIComponent(query),
                            page,
                            tags: allTags.map(this.getTagName),
                            levels: allLevels.map(this.getLevelName),
                            city: decodeURIComponent(city),
                            // currency: decodeURIComponent(currency),
                            is_online: allIsOnline.map(decodeURIComponent),
                            is_pack: allIsPack.map(decodeURIComponent),
                            device_types: allDeviceTypes.map(
                                this.getDeviceTypeName
                            ),
                        };
                    },
                }),
                stateMapping: {
                    stateToRoute: (uiState) => {
                        const indexUiState = uiState[indexName] || {};

                        return {
                            query: indexUiState.query,
                            page: indexUiState.page,
                            tags:
                                indexUiState.refinementList &&
                                indexUiState.refinementList.tags,
                            levels:
                                indexUiState.refinementList &&
                                indexUiState.refinementList.levels,
                            city: indexUiState.menu && indexUiState.menu.city,
                            // currency: indexUiState.menu && indexUiState.menu.currency,
                            is_online:
                                indexUiState.refinementList &&
                                indexUiState.refinementList.is_online,
                            is_pack:
                                indexUiState.refinementList &&
                                indexUiState.refinementList.is_pack,
                            device_types:
                                indexUiState.refinementList &&
                                indexUiState.refinementList.device_types,
                        };
                    },

                    routeToState: (routeState) => {
                        let uiState = [];
                        uiState[indexName] = {
                            query: routeState.query,
                            page: routeState.page,
                            menu: {
                                city: routeState.city,
                                // currency: routeState.currency,
                            },
                            refinementList: {
                                tags: routeState.tags,
                                levels: routeState.levels,
                                device_types: routeState.device_types,
                                is_online: routeState.is_online,
                                is_pack: routeState.is_pack,
                            },
                        };

                        return uiState;
                    },
                },
            },
            searchCityTerm: '',
            // searchCurrencyTerm: '',
            lockToggleShowMore: false,
            mustToggleShowMoreOnReset: false,
            indexName: indexName,
            selectedCityHTML: selectedCityHTML,
            isHeaderSticky: isHeaderSticky,
        };
    },

    methods: {
        // Returns a slug from the tag name.
        getTagSlug(name) {
            let tag = appData.page.vars.tagsSlugs.find(
                (tag) => tag.label === name
            );

            return tag.slug;
        },

        // Returns a name from the tag slug.
        getTagName(slug) {
            if (slug != '') {
                let tag = appData.page.vars.tagsSlugs.find(
                    (tag) => tag.slug === slug
                );

                return tag.label;
            } else {
                return '';
            }
        },

        // Returns a slug from the level name.
        getLevelSlug(name) {
            let level = appData.page.vars.levelsSlugs.find(
                (level) => level.label === name
            );

            return level.slug;
        },

        // Returns a name from the level slug.
        getLevelName(slug) {
            if (slug != '') {
                let level = appData.page.vars.levelsSlugs.find(
                    (level) => level.slug === slug
                );

                return level.label;
            } else {
                return '';
            }
        },

        // Returns a slug from the device type name.
        getDeviceTypeSlug(name) {
            let deviceType = appData.page.vars.deviceTypesSlugs.find(
                (deviceType) => deviceType.label === name
            );

            return deviceType.slug;
        },

        // Returns a name from the device type slug.
        getDeviceTypeName(slug) {
            if (slug != '') {
                let deviceType = appData.page.vars.deviceTypesSlugs.find(
                    (deviceType) => deviceType.slug === slug
                );

                return deviceType.label;
            } else {
                return '';
            }
        },

        getNumericPriceSlug(name) {
            let index = name.indexOf(':');

            let minPrice = name.slice(0, index);
            let maxPrice = name.slice(index + 1, name.length);

            let slug = '';

            if (minPrice.length > 0) {
                slug += '≥' + minPrice;
            }

            if (minPrice.length > 0 && maxPrice.length > 0) {
                slug += 'AND';
            }

            if (maxPrice.length > 0) {
                slug += '≤' + maxPrice;
            }

            return slug;
        },

        getNumericPriceName(slug) {
            if (slug != '') {
                let andIndex = slug.indexOf('AND');
                let minIndex = slug.indexOf('≥');
                let maxIndex = slug.indexOf('≤');

                let name = '';

                if (andIndex != -1) {
                    if (minIndex != -1) {
                        name += slug.slice(1, andIndex);
                    }

                    name += ':';

                    if (maxIndex != -1) {
                        name += slug.slice(maxIndex + 1, slug.length);
                    }
                } else {
                    if (minIndex != -1) {
                        name += slug.slice(1, slug.length);
                    }

                    name += ':';

                    if (maxIndex != -1) {
                        name += slug.slice(1, slug.length);
                    }
                }

                return name;
            } else {
                return '';
            }
        },

        toValue(value, range) {
            let min = range.min;
            let max = range.max;

            if (
                value.min !== null &&
                value.min !== undefined &&
                value.min > range.min
            ) {
                min = value.min;
            }

            if (
                value.max !== null &&
                value.max !== undefined &&
                value.max < range.max
            ) {
                max = value.max;
            }

            return [min, max];
        },

        aisFilters() {
            let aisFilters = this.langFilter;

            console.debug(this.selectedCurrencyCode);

            aisFilters += ' AND currency: ' + this.selectedCurrencyCode;

            console.debug(aisFilters);

            return aisFilters;
        },

        searchCityTermInput(value) {
            if (value != '') {
                this.lockToggleShowMore = true;
                this.searchCityTerm = value;

                if (!this.$refs.cityMenu.state.isShowingMore) {
                    this.$refs.cityMenu.state.toggleShowMore();
                    this.mustToggleShowMoreOnReset = true;
                }
            } else {
                this.searchCityTermReset();
            }
        },

        searchCityTermReset() {
            this.searchCityTerm = '';
            this.lockToggleShowMore = false;

            if (this.mustToggleShowMoreOnReset) {
                this.$refs.cityMenu.state.toggleShowMore();
                this.mustToggleShowMoreOnReset = false;
            }
        },

        filterCityMenuItems(items) {
            return items.filter((item) =>
                item.label
                    .toLowerCase()
                    .includes(this.searchCityTerm.toLowerCase())
            );
        },

        // searchCurrencyTermInput(value) {
        //     if (value != '') {
        //         this.lockToggleShowMore = true;
        //         this.searchCurrencyTerm = value;

        //         if (!this.$refs.currencyMenu.state.isShowingMore) {
        //             this.$refs.currencyMenu.state.toggleShowMore();
        //             this.mustToggleShowMoreOnReset = true;
        //         }
        //     } else {
        //         this.searchCurrencyTermReset();
        //     }
        // },

        // searchCurrencyTermReset() {
        //     this.searchCurrencyTerm = '';
        //     this.lockToggleShowMore = false;

        //     if (this.mustToggleShowMoreOnReset) {
        //         this.$refs.currencyMenu.state.toggleShowMore();
        //         this.mustToggleShowMoreOnReset = false;
        //     }
        // },

        // filterCurrencyMenuItems(items) {
        //     return items.filter(item =>
        //         item.label.toLowerCase().includes(this.searchCurrencyTerm.toLowerCase())
        //     );
        // },

        /**
         * Sort tags by isRefined then the custom tags order
         */
        sortTags: function (a, b) {
            return (
                b.isRefined - a.isRefined ||
                this.tagsOrder[a.name] - this.tagsOrder[b.name]
            );
        },

        refineArticlesBySearchInput(refine, inputRef) {
            this.refineArticles(refine, this.$refs.inputSearchArticles.value);
        },

        refineArticlesByRemovingFilter(refinement, item) {
            this.scrollUp(100);
            item.refine(refinement);
        },

        refineArticles(refine, value = null) {
            // scroll to top of the resultset
            this.scrollUp(100);
            if (value === null) {
                // reset refinements
                refine();
            } else {
                // refine unsing newly provided value
                refine(value);
            }
        },

        onClickClearRefinements(refine) {
            this.refineArticles(refine);
        },

        /**
         * Scroll to the top of the courses list
         * Can be used for example when a user click on the next page in the courses pagination
         */
        scrollUp(timer = 300) {
            setTimeout(() => {
                document.getElementById('courses').scrollIntoView();
            }, timer);
        },

        formatPrice(price, currencyCode) {
            return window.app.formatPrice(price, currencyCode);
        },

        getSelectedCurrencyHTML() {
            return (
                '<strong>' + window.app.getSelectedCurrency().name + '</strong>'
            );
        },

        transformBooleanItems(items) {
            return items.map((item) => ({
                ...item,
                label:
                    item.label == 'true'
                        ? app.locale.trans(
                              'pages/course/search.filters.dropdown.yes'
                          )
                        : app.locale.trans(
                              'pages/course/search.filters.dropdown.no'
                          ),
            }));
        },
    },
};
</script>
